import { Avatar, Box, Divider, IconButton, List, ListItemButton, ListItemIcon, Tooltip } from "@mui/material"
import { styled } from "@mui/styles"
import MainFrame from "../../components/mainFrame"
import { Row } from "../../global/styledComponents"
import FilterListIcon from '@mui/icons-material/FilterList';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TextContainer from "../../components/Texts/TextContainer";
import Chat from "../chat";
import { Helmet } from "react-helmet";


const Container = styled(Box)({
    padding: "1rem",
    width: "100%",
    height: "100%",
    gap: ".5rem",
    minHeight: "90vh",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    maxHeight: "90vh"
})
const SideMenu = styled(Box)({
    borderRadius: "15px",
    height: "100%",
    maxWidth: "20%",
    minWidth: "15%",
    width: "100%",
    padding: ".5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    borderWidth: "1px",
    borderStyle: "solid"
})
const Card = styled(Box)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: ".8rem",
    maxWidth: "20%",
    minWidth: "15%",
    width: "100%",
})

function Ticketing() {
    const d = new Date()
    return (
        <Container bgcolor="primary.light">
            <Helmet>
                <title> تیکت ها | پنل ادمین yaadin</title>
            </Helmet>
            <SideMenu borderColor="divider">
                <Row>
                    <IconButton><FilterListIcon sx={{ color: "divider" }} /></IconButton>
                </Row>
                <List sx={{ width: "100%" }}>
                    <Tooltip title="جواب داده شده">
                        <ListItemButton sx={{
                            bgcolor: "divider", borderRadius: "12px", padding: "0 .5rem", ":hover": {
                                bgcolor: "customColors.purple"
                            }
                        }}>
                            <ListItemIcon>
                                <CheckCircleIcon sx={{ color: "green" }} />
                            </ListItemIcon>
                            <Box>
                                <TextContainer
                                    color="primary.main"
                                    fontSize="1rem"
                                    width="100%"
                                    justifyContent="right"
                                >
                                    عنوان
                                </TextContainer>
                                <TextContainer
                                    color="primary.light"
                                    fontSize=".6rem"
                                    width="100%"
                                    justifyContent="right"
                                >
                                    {new Intl.DateTimeFormat('fa-IR', { dateStyle: 'full', timeStyle: "short" }).format(d)}
                                </TextContainer>
                            </Box>
                        </ListItemButton>
                    </Tooltip>
                </List>
            </SideMenu>
            <Chat />
            <Card bgcolor="secondary.main">
                <Row>
                    <Avatar alt="Alice" src="https://material-ui.com/static/images/avatar/7.jpg" />
                    <Box width="100%">
                        <TextContainer justifyContent="right" width="100%" fontSize="1rem" color="primary.main">نام کاربری</TextContainer>
                        <Row width="100%">
                            <TextContainer justifyContent="right" width="100%" fontSize=".7rem" color="green">کاربر</TextContainer>
                            <TextContainer justifyContent="left" width="100%" fontSize=".7rem" color="primary.main">email@gmail.com</TextContainer>
                        </Row>
                        <TextContainer justifyContent="left" width="100%" fontSize=".7rem" color="primary.main">09304065658</TextContainer>
                    </Box>
                </Row>
                <Divider />
                <List>
                    <Row justifyContent="space-between" width="100%">
                        <TextContainer fontFamily="'YekanBold !important'" fontSize=".8rem" width="100%" justifyContent="right" color="primary.main">وضعیت</TextContainer>
                        <TextContainer color="green" width="100%" justifyContent="right" fontSize=".7rem">جواب داده شده</TextContainer>
                    </Row>
                    <Row justifyContent="space-between" width="100%">
                        <TextContainer fontFamily="'YekanBold !important'" fontSize=".8rem" width="100%" justifyContent="right" color="primary.main">تاریخ ایجاد</TextContainer>
                        <TextContainer width="100%" justifyContent="right" color="primary.light" fontSize=".7rem">
                            {new Intl.DateTimeFormat('fa-IR', { dateStyle: 'full', timeStyle: "short" }).format(d)}
                        </TextContainer>
                    </Row>
                    <Row justifyContent="space-between" width="100%">
                        <TextContainer fontFamily="'YekanBold !important'" fontSize=".8rem" width="100%" justifyContent="right" color="primary.main">تاریخ آخرین تغییر</TextContainer>
                        <TextContainer width="100%" justifyContent="right" color="primary.light" fontSize=".7rem">
                            {new Intl.DateTimeFormat('fa-IR', { dateStyle: 'full', timeStyle: "short" }).format(d)}
                        </TextContainer>
                    </Row>
                </List>
            </Card>
        </Container>
    )
}
export default MainFrame(Ticketing)